import React from 'react';
import './ContactCard.css';
import { IconSun, IconAt, IconBrandWhatsapp } from '@tabler/icons-react';
import ContactCardIcon from "../../../components/ContactCardIcon/ContactCardIcon";
import ContactForm from "../ContactForm/ContactForm";
import { emailTo } from "../../../utils/emailTo";
import { wappTo } from "../../../utils/wappTo";

// Mapeo de títulos a iconos. Cuando se cambia el title del JSON, debe actualizarse este titulo para poder mostrar el icono específico.
const iconMap = {
    'Email': IconAt,
    'Teléfono': IconBrandWhatsapp,
    'Horario de atención': IconSun
};

function ContactCard({ courseData, subject, message, data, formTitle, contactTitle, formData }) {
    const items = data.map((item, index) => {
        const IconComponent = iconMap[item.title];
        const onClickHandler = item.title === 'Email'
            ? (to) => emailTo(to, subject)
            : item.title === 'Telefono'
                ? (to) => wappTo(to.replace(/\s/g, ''), message)
                : null;

        return (
            <ContactCardIcon
                key={index}
                title={item.title}
                description={item.description}
                icon={IconComponent}
                info={item.info}
                onClick={onClickHandler}
            />
        );
    });

    return (
        <div className="contactCard-wrapper">
            <div className="contactCard-contacts">
                <h3 className="contactCard-title contactCard-title--left">
                    {contactTitle}
                </h3>
                <div className="contactCard-items">
                    {items}
                </div>
            </div>
            <div className="contactCard-form">
                <h3 className="contactCard-title contactCard-title--right">
                    {formTitle}
                </h3>
                <div className="contactCard-fields">
                    <ContactForm formData={formData} courseData={courseData}/>
                </div>
            </div>
        </div>
    );
}

export default ContactCard;
